// extracted by mini-css-extract-plugin
module.exports = {"contactWaiting":"Waiting-module--contactWaiting--2Ee_Q","oval":"Waiting-module--oval--25NDy"};